import React from 'react';
import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';

import { ApplicationError } from '../application-error';

export default function ErrorBoundary({ children }) {
  return (
    <Sentry.ErrorBoundary fallback={({ eventId }) => <ApplicationError eventId={eventId} />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};
